import { html } from '@utils/rendering/html';
import { Route, Router } from 'preact-iso';
import Admin from './core/components/admin';
import LandingPage from './core/components/landing-page';
import LoginPage from './core/components/login-page';
import { ERMPortalUrls } from './core/constants/routing/urls.constants';
import { MicroAppRoute } from './core/utils/routing/micro-loader';
import { Systems } from './core/constants/security/systems.constants';
import { Roles } from './core/constants/security/roles.constants';
import { AdminTabsConfig } from './core/configs/navigation/admin/admin-tabs.config';

import withAuthGuard from './core/utils/routing/with-auth-guard';
import withRoleGuard from './core/utils/routing/with-role-guard';

const GuardedLandingPage = withAuthGuard(LandingPage);
const RdarrGuarded = withAuthGuard(
    withRoleGuard(MicroAppRoute, { system: Systems.RDARR, required: [], mode: 'any' })
);
const IndicatorGuarded = withAuthGuard(
    withRoleGuard(MicroAppRoute, { system: Systems.Indicators, required: [], mode: 'any' })
);
const EwisGuarded = withAuthGuard(
    withRoleGuard(MicroAppRoute, { system: Systems.EWIS, required: [], mode: 'any' })
);
const RiskAppetiteGuarded = withAuthGuard(
    withRoleGuard(MicroAppRoute, { system: Systems.RiskAppetite, required: [], mode: 'any' })
);
const GuardedAdmin = withAuthGuard(
    withRoleGuard(Admin, { required: [Roles.Admin, Roles.Developer], mode: 'any' })
);

// Micro-app routes must not be keyed on the URL: a remote navigates inside itself through
// onNavigate, and a changing key would remount MicroAppRoute and re-run mount() (a fresh relay
// token and relay-exchange, i.e. a duplicate sign-in) on every internal navigation.
const App = () => {
    return html`
        <${Router}>
            <${Route} path=${ERMPortalUrls.logout} component=${LoginPage} />
            <${Route} path=${ERMPortalUrls.base} component=${GuardedLandingPage} />

            <${Route} path="${ERMPortalUrls.ewis}/:subpath*"
                component=${EwisGuarded} appName="ewis" currentPath=${ERMPortalUrls.ewis} />
            <${Route} path="${ERMPortalUrls.rdarr}/:subpath*"
                component=${RdarrGuarded} appName="rdarr" currentPath=${ERMPortalUrls.rdarr} />
            <${Route} path="${ERMPortalUrls.riskAppetite}/:subpath*"
                component=${RiskAppetiteGuarded} appName="riskAppetite" currentPath=${ERMPortalUrls.riskAppetite} />
            <${Route} path="${ERMPortalUrls.indicatorMicroservice}/:subpath*"
                component=${IndicatorGuarded} appName="indicators" currentPath=${ERMPortalUrls.indicatorMicroservice} />

            <${Route} path=${ERMPortalUrls.admin} component=${GuardedAdmin} />
            <${Route} path=${ERMPortalUrls.adminUsers} component=${GuardedAdmin} activePage=${AdminTabsConfig[0]} />
            <${Route} path=${ERMPortalUrls.adminSystems} component=${GuardedAdmin} activePage=${AdminTabsConfig[1]} />
        </${Router}>
    `;
};

export default App;
